module.exports = __webpack_public_path__ + "static/media/white.7832baac.jpg";